import { useNavigate } from "react-router-dom";
import { useAuth } from "../../providers/authProvider";
import Cookies from 'js-cookie';

const Logout = () => {
    const { setToken } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        setToken();
        Cookies.remove('userRole');
        navigate("/", { replace: true });
    };
    handleLogout();

    return <>Logout Page</>;
};

export default Logout;